export const HELP_CATEGORIES = [
  {
    id: "getting-started",
    nameKey: "help.category.getting_started",
    icon: "Rocket",
    color: "text-emerald-400",
  },
  {
    id: "agents",
    nameKey: "help.category.agents",
    icon: "Bot",
    color: "text-blue-400",
  },
  {
    id: "automations",
    nameKey: "help.category.automations",
    icon: "Workflow",
    color: "text-purple-400",
  },
  {
    id: "integrations",
    nameKey: "help.category.integrations",
    icon: "Plug",
    color: "text-amber-400",
  },
  {
    id: "billing",
    nameKey: "help.category.billing",
    icon: "CreditCard",
    color: "text-rose-400",
  },
  {
    id: "troubleshooting",
    nameKey: "help.category.troubleshooting",
    icon: "Wrench",
    color: "text-orange-400",
  },
];

export const HELP_ARTICLES = [
  // Getting Started (4 articles)
  {
    id: "gs-1",
    category: "getting-started",
    titleKey: "help.article.gs1.title",
    contentKey: "help.article.gs1.content",
    readTime: 3,
    popular: true,
  },
  {
    id: "gs-2",
    category: "getting-started",
    titleKey: "help.article.gs2.title",
    contentKey: "help.article.gs2.content",
    readTime: 5,
    popular: true,
  },
  {
    id: "gs-3",
    category: "getting-started",
    titleKey: "help.article.gs3.title",
    contentKey: "help.article.gs3.content",
    readTime: 4,
    popular: false,
  },
  {
    id: "gs-4",
    category: "getting-started",
    titleKey: "help.article.gs4.title",
    contentKey: "help.article.gs4.content",
    readTime: 6,
    popular: false,
  },

  // Agents (4 articles)
  {
    id: "ag-1",
    category: "agents",
    titleKey: "help.article.ag1.title",
    contentKey: "help.article.ag1.content",
    readTime: 5,
    popular: true,
  },
  {
    id: "ag-2",
    category: "agents",
    titleKey: "help.article.ag2.title",
    contentKey: "help.article.ag2.content",
    readTime: 4,
    popular: false,
  },
  {
    id: "ag-3",
    category: "agents",
    titleKey: "help.article.ag3.title",
    contentKey: "help.article.ag3.content",
    readTime: 7,
    popular: true,
  },
  {
    id: "ag-4",
    category: "agents",
    titleKey: "help.article.ag4.title",
    contentKey: "help.article.ag4.content",
    readTime: 3,
    popular: false,
  },

  // Automations (3 articles)
  {
    id: "au-1",
    category: "automations",
    titleKey: "help.article.au1.title",
    contentKey: "help.article.au1.content",
    readTime: 6,
    popular: true,
  },
  {
    id: "au-2",
    category: "automations",
    titleKey: "help.article.au2.title",
    contentKey: "help.article.au2.content",
    readTime: 5,
    popular: false,
  },
  {
    id: "au-3",
    category: "automations",
    titleKey: "help.article.au3.title",
    contentKey: "help.article.au3.content",
    readTime: 4,
    popular: false,
  },

  // Integrations (3 articles)
  {
    id: "in-1",
    category: "integrations",
    titleKey: "help.article.in1.title",
    contentKey: "help.article.in1.content",
    readTime: 4,
    popular: true,
  },
  {
    id: "in-2",
    category: "integrations",
    titleKey: "help.article.in2.title",
    contentKey: "help.article.in2.content",
    readTime: 5,
    popular: false,
  },
  {
    id: "in-3",
    category: "integrations",
    titleKey: "help.article.in3.title",
    contentKey: "help.article.in3.content",
    readTime: 3,
    popular: false,
  },

  // Billing (3 articles)
  {
    id: "bl-1",
    category: "billing",
    titleKey: "help.article.bl1.title",
    contentKey: "help.article.bl1.content",
    readTime: 3,
    popular: true,
  },
  {
    id: "bl-2",
    category: "billing",
    titleKey: "help.article.bl2.title",
    contentKey: "help.article.bl2.content",
    readTime: 4,
    popular: false,
  },
  {
    id: "bl-3",
    category: "billing",
    titleKey: "help.article.bl3.title",
    contentKey: "help.article.bl3.content",
    readTime: 3,
    popular: false,
  },

  // Troubleshooting (3 articles)
  {
    id: "tr-1",
    category: "troubleshooting",
    titleKey: "help.article.tr1.title",
    contentKey: "help.article.tr1.content",
    readTime: 5,
    popular: true,
  },
  {
    id: "tr-2",
    category: "troubleshooting",
    titleKey: "help.article.tr2.title",
    contentKey: "help.article.tr2.content",
    readTime: 4,
    popular: false,
  },
  {
    id: "tr-3",
    category: "troubleshooting",
    titleKey: "help.article.tr3.title",
    contentKey: "help.article.tr3.content",
    readTime: 6,
    popular: false,
  },
];

export const FAQ_ITEMS = [
  {
    id: "faq-1",
    questionKey: "help.faq.q1.question",
    answerKey: "help.faq.q1.answer",
  },
  {
    id: "faq-2",
    questionKey: "help.faq.q2.question",
    answerKey: "help.faq.q2.answer",
  },
  {
    id: "faq-3",
    questionKey: "help.faq.q3.question",
    answerKey: "help.faq.q3.answer",
  },
  {
    id: "faq-4",
    questionKey: "help.faq.q4.question",
    answerKey: "help.faq.q4.answer",
  },
  {
    id: "faq-5",
    questionKey: "help.faq.q5.question",
    answerKey: "help.faq.q5.answer",
  },
  {
    id: "faq-6",
    questionKey: "help.faq.q6.question",
    answerKey: "help.faq.q6.answer",
  },
];

export const QUICK_LINKS = [
  {
    id: "docs",
    titleKey: "help.quick_links.docs",
    descKey: "help.quick_links.docs_desc",
    url: "/docs/api",
    icon: "BookOpen",
  },
  {
    id: "community",
    titleKey: "help.quick_links.community",
    descKey: "help.quick_links.community_desc",
    url: "/community",
    icon: "Users",
  },
  {
    id: "api",
    titleKey: "help.quick_links.api",
    descKey: "help.quick_links.api_desc",
    url: "/docs/api",
    icon: "Code",
  },
];
